import {
    Box,
    Grid,
    Hidden,
    Skeleton,
    Theme,
    Typography
} from "@mui/material";

export function SchemeInfoSkeleton(): JSX.Element {
    return (
        <>
            <Hidden lgUp>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: { xs: "3px", sm: "15px" },
                    }}
                >
                    <Skeleton
                        variant="rounded"
                        animation="wave"
                        sx={{ borderRadius: "8px", width: { xs: 40, sm: 50 }, height: { xs: 40, sm: 50 } }}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            flex: '1',
                            rowGap: "7px"
                        }}
                    >
                        <Skeleton
                            animation="wave"
                            sx={{ fontSize: '18px', width: { xs: "70%", sm: "100%" } }}
                        />
                        <Box
                            sx={{
                                display: "flex",
                                columnGap: { xs: "2px", sm: "10px" },
                                alignItems: "center"
                            }}
                        >
                            <Skeleton
                                animation="wave"
                                sx={{ fontSize: '16px', width: { xs: "2rem", sm: "3rem" } }}
                            />
                            <Skeleton
                                animation="wave"
                                variant="rounded"
                                width={3}
                                height={3}
                                sx={{ borderRadius: "50%" }}
                            />
                            <Skeleton
                                animation="wave"
                                sx={{ fontSize: '16px', width: { xs: "2rem", sm: "3rem" } }}
                            />
                            <Skeleton
                                animation="wave"
                                variant="rounded"
                                width={3}
                                height={3}
                                sx={{ borderRadius: "50%" }}
                            />
                            <Skeleton
                                animation="wave"
                                sx={{ fontSize: '16px', width: { xs: "2rem", sm: "3rem" } }}
                            />
                        </Box>
                    </Box>
                </Box>
            </Hidden>
            <Hidden lgDown>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "10px"
                    }}
                >
                    <Box sx={{ display: "flex", columnGap: "15px", alignItems: "center" }}>
                        <Skeleton
                            variant="rounded"
                            animation="wave"
                            width={50}
                            height={50}
                            sx={{ borderRadius: "8px" }}
                        />
                        <Skeleton
                            animation="wave"
                            sx={{ fontSize: '18px' }}
                            width="100%"
                        />
                    </Box>
                    <Box sx={{ display: "flex", columnGap: "5px", alignItems: "center" }}>
                        <Skeleton
                            animation="wave"
                            variant="rounded"
                            width={3}
                            height={3}
                            sx={{ borderRadius: "50%" }}
                        />
                        <Skeleton
                            animation="wave"
                            sx={{ fontSize: '16px' }}
                            width="3rem"
                        />
                    </Box>
                    <Box sx={{ display: "flex", columnGap: "5px", alignItems: "center" }}>
                        <Skeleton
                            animation="wave"
                            variant="rounded"
                            width={3}
                            height={3}
                            sx={{ borderRadius: "50%" }}
                        />
                        <Skeleton
                            animation="wave"
                            sx={{ fontSize: '16px' }}
                            width="3rem"
                        />
                    </Box>
                    <Box sx={{ display: "flex", columnGap: "5px", alignItems: "center" }}>
                        <Skeleton
                            animation="wave"
                            variant="rounded"
                            width={3}
                            height={3}
                            sx={{ borderRadius: "50%" }}
                        />
                        <Skeleton
                            animation="wave"
                            sx={{ fontSize: '16px' }}
                            width="3rem"
                        />
                    </Box>
                </Box>
            </Hidden>
        </>
    )
}


function CartItemInfoSkeleton({ showToScheme }: { showToScheme: boolean }) {
    return (
        <>
            <Hidden lgUp>
                <Box>
                    <Grid
                        container
                        flexWrap="nowrap"
                        sx={{ columnGap: "15px" }}
                    >
                        <Grid
                            item
                            container
                            xs={10}
                            flexWrap="nowrap"
                            sx={{ columnGap: "15px" }}
                        >
                            <Grid item>
                                <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    width={24}
                                    height={24}
                                />
                            </Grid>
                            <Grid
                                item
                                container
                                flexDirection="column"
                                sx={{ rowGap: "10px" }}
                            >
                                <SchemeInfoSkeleton />
                                {showToScheme && (
                                    <>
                                        <Skeleton
                                            variant="rounded"
                                            height={40}
                                            width={10}
                                            animation="wave"
                                        />
                                        <SchemeInfoSkeleton />
                                    </>
                                )}
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            container
                            xs={2}
                            justifyContent="flex-end"
                            alignItems="flex-start"
                            sx={{ columnGap: "8px" }}
                        >
                            <Skeleton
                                animation="wave"
                                variant="rounded"
                                width={20}
                                height={20}
                            />
                            <Skeleton
                                animation="wave"
                                variant="rounded"
                                width={20}
                                height={20}
                            />
                        </Grid>
                    </Grid>
                    <Box sx={{ marginTop: "35px" }}>
                        {[...Array(8)].map((_, index) => (
                            <Grid
                                key={index}
                                container
                                sx={{ marginBottom: "25px" }}
                            >
                                <Grid item xs={5}>
                                    <Skeleton
                                        animation="wave"
                                        sx={{ fontSize: '16px' }}
                                        width="7rem"
                                    />
                                </Grid>
                                <Grid
                                    item
                                    container
                                    xs={7}
                                    sx={{ justifyContent: "flex-end" }}
                                >
                                    <Skeleton
                                        animation="wave"
                                        sx={{ fontSize: '18px' }}
                                        width="7rem"
                                    />
                                </Grid>
                            </Grid>
                        ))}
                    </Box>
                </Box >
            </Hidden >
            <Hidden lgDown>
                <Box>
                    <Grid
                        container
                        flexWrap="nowrap"
                        sx={{ columnGap: "15px" }}
                    >
                        <Grid
                            item
                            container
                            xs={10.5}
                            flexWrap="nowrap"
                            sx={{ columnGap: "15px" }}
                        >
                            <Grid
                                item
                                container
                                xs="auto"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    width={24}
                                    height={24}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={6}
                            >
                                <SchemeInfoSkeleton />
                            </Grid>
                            {showToScheme && (
                                <>
                                    <Grid
                                        item
                                        container
                                        xs={2}
                                        justifyContent="center"
                                        alignItems="center"
                                    >
                                        <Skeleton
                                            variant="rounded"
                                            height={15}
                                            width="100%"
                                            animation="wave"
                                        />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <SchemeInfoSkeleton />
                                    </Grid>
                                </>
                            )}
                        </Grid>
                        <Grid
                            item
                            container
                            xs={1.5}
                            justifyContent="flex-end"
                            alignItems="flex-start"
                            sx={{ columnGap: "8px" }}
                        >
                            <Skeleton
                                animation="wave"
                                variant="rounded"
                                width={20}
                                height={20}
                            />
                            <Skeleton
                                animation="wave"
                                variant="rounded"
                                width={20}
                                height={20}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        sx={{
                            marginTop: "35px",
                            marginLeft: "37px",
                            rowGap: "30px",
                        }}
                    >
                        {[...Array(8)].map((_, index) => (
                            <Grid
                                item
                                container
                                xs={3}
                                key={index}
                                sx={{
                                    rowGap: "8px",
                                    paddingRight: "30px",
                                }}
                            >
                                <Grid item xs={12}>
                                    <Skeleton
                                        animation="wave"
                                        sx={{ fontSize: '16px' }}
                                        width="7rem"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton
                                        animation="wave"
                                        sx={{ fontSize: '18px' }}
                                        width="7rem"
                                    />
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Box >
            </Hidden >
        </>
    )
}

export default function LoadingComponent({ showToScheme }: { showToScheme: boolean }): JSX.Element {
    return (
        <Box>
            <Typography
                variant="h1"
                sx={(theme: Theme) => ({
                    lineHeight: "32.5px",
                    color: theme.palette.text.primary
                })}
            >
                Cart
            </Typography>
            <Box
                sx={(theme: Theme) => ({
                    marginTop: "25px",
                    paddingBottom: "15px",
                    borderBottom: `0.5px solid ${theme.palette.customColors.pastelGrey}`,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: '20px',
                    overflowX: 'auto',
                    whiteSpace: 'nowrap',
                    scrollbarWidth: 'none', // Hide scrollbar in Firefox
                    '&::-webkit-scrollbar': {
                        display: 'none', // Hide scrollbar in WebKit browsers
                    },
                })}
            >
                {[...Array(6)].map((_, index) => (
                    <Skeleton
                        key={index}
                        animation="wave"
                        variant="rounded"
                        height={31.5}
                        width={140}
                        sx={{ borderRadius: "7px" }}
                    />
                ))}
            </Box>
            <Grid
                container
                sx={{ marginTop: "25px" }}
                spacing={3}
            >
                <Grid
                    item
                    xs={12}
                    lg={8}
                >
                    <Box
                        sx={(theme: Theme) => ({
                            borderRadius: "20px",
                            backgroundColor: theme.palette.common.white,
                            padding: "25px 30px 35px 20px",
                            boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
                        })}
                    >
                        <Skeleton
                            animation="wave"
                            sx={{ fontSize: '20px' }}
                            width="12.5rem"
                        />
                        <Box
                            sx={{
                                marginTop: "35px",
                                display: "flex",
                                flexDirection: "column",
                                rowGap: "35px"
                            }}
                        >
                            <CartItemInfoSkeleton showToScheme={showToScheme} />
                            <Box sx={(theme: Theme) => ({ border: `0.1px solid ${theme.palette.text.secondary}B3` })} />
                            <CartItemInfoSkeleton showToScheme={showToScheme} />
                        </Box>
                    </Box>
                    <Box
                        sx={(theme: Theme) => ({
                            marginTop: "25px",
                            borderRadius: "20px",
                            backgroundColor: theme.palette.common.white,
                            padding: "35px 30px 35px 20px",
                            boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
                        })}
                    >
                        <Skeleton
                            animation="wave"
                            sx={{ fontSize: '20px' }}
                            width="12.5rem"
                        />
                        <Box
                            sx={{
                                marginTop: "35px",
                                display: "flex",
                                flexDirection: "column",
                                rowGap: "35px"
                            }}
                        >
                            <CartItemInfoSkeleton showToScheme={showToScheme} />
                            <Box sx={(theme: Theme) => ({ border: `0.1px solid ${theme.palette.text.secondary}B3` })} />
                            <CartItemInfoSkeleton showToScheme={showToScheme} />
                        </Box>
                    </Box>
                </Grid>
                <Grid
                    item
                    xs={12}
                    lg={4}
                >
                    <Box
                        sx={(theme: Theme) => ({
                            borderRadius: "20px",
                            padding: "25px 30px 30px 30px",
                            backgroundColor: theme.palette.common.white,
                            boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
                        })}
                    >
                        <Box
                            sx={(theme: Theme) => ({
                                display: "flex",
                                columnGap: "15px",
                                alignItems: "center",
                                paddingBottom: "35px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`
                            })}>
                            <Skeleton
                                variant="circular"
                                animation="wave"
                                width={58}
                                height={58}
                            />
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: "5px",
                                }}
                            >
                                <Skeleton
                                    animation="wave"
                                    sx={{ fontSize: '20px' }}
                                    width="10rem"
                                />
                                <Skeleton
                                    animation="wave"
                                    sx={{ fontSize: '16px' }}
                                    width="8rem"
                                />
                            </Box>
                        </Box>
                        <Hidden lgUp>
                            <Box
                                sx={{
                                    marginTop: "35px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    columnGap: "10px"
                                }}
                            >
                                <Skeleton
                                    animation="wave"
                                    sx={{ fontSize: '14px' }}
                                    width="8rem"
                                />
                                <Skeleton
                                    animation="wave"
                                    sx={{ fontSize: '20px' }}
                                    width="8rem"
                                />
                            </Box>
                        </Hidden>
                        <Hidden lgDown>
                            <Box
                                sx={{
                                    marginTop: "35px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    rowGap: "10px"
                                }}
                            >
                                <Skeleton
                                    animation="wave"
                                    sx={{ fontSize: '22px' }}
                                    width="8rem"
                                />
                                <Skeleton
                                    animation="wave"
                                    sx={{ fontSize: '16px' }}
                                    width="8rem"
                                />
                            </Box>
                        </Hidden>
                        <Skeleton
                            variant="rounded"
                            animation="wave"
                            width="100%"
                            height={50}
                            sx={{
                                marginTop: "35px",
                                borderRadius: "10px"
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box >
    )
}